import React from 'react';
import BatchManagementV4 from '../components/BatchManagementV4';

const BatchManagementV4Page: React.FC = () => {
    return (
        <div className="batch-management-v4-page">
            <BatchManagementV4 />
        </div>
    );
};

export default BatchManagementV4Page;
